<template>
    <Form :ref="refName" :rules="ruleValidate"  :model="updateInfo" :label-width="100">
        <Row :gutter="16">
            <Col span="8">
                <FormItem label="选择项目" prop="projectId">
                    <Select v-model="updateInfo.projectId" placeholder="请选择项目">
                        <Option :value="item.projectId" v-for="item in $coreData.projectList" :key="item.projectID">
                            {{item.projectId + ' - ' + item.projectName}}
                        </Option>
                    </Select>
                </FormItem>
            </Col>
            <Col span="8">
                <FormItem label="终端起始ID" prop="startDeviceId">
                    <Input v-model="updateInfo.startDeviceId" placeholder="请输入数字序列" />
                </FormItem>
            </Col>
            <Col span="8">
                <FormItem label="终端结束ID" prop="endDeviceId">
                    <Input v-model="updateInfo.endDeviceId" placeholder="请输入数字序列" />
                </FormItem>
            </Col>
        </Row>
        <Row :gutter="16">
            <Col span="8">
                <FormItem label="固件版本" prop="codeId">
                    <Input v-model="updateInfo.codeId" placeholder="范围01-FF" />
                </FormItem>
            </Col>
            <Col span="16">
                <FormItem label="固件文件名" prop="fileName">
                    <div style="display: flex; flex-direction: row">
                        <Input v-model="updateInfo.fileName" readonly style="flex-grow: 1; margin-right: 8px" placeholder='请单击"..."按钮选择固件文件' />
                        <Upload action="/uploadFile" name="code" accept=".bin" :show-upload-list="false" :before-upload="beforeUpload" style="display: inline-block">
                            <Button >...</Button>
                        </Upload>
                    </div>
                </FormItem>
            </Col>
        </Row>
        <FormItem style="text-align: right; margin-bottom: 0">
            <Button type="primary" style="width: 90px" @click="handleSubmit">提交</Button>
            <Button style="margin-left: 8px; width: 90px"  @click="handleReset">重置</Button>
            <Button style="margin-left: 8px; width: 90px" @click="getLastRecord">最近设置</Button>
            <Button style="margin-left: 8px; width: 90px" disabled>开始升级</Button>
        </FormItem>
    </Form>
</template>

<script>
    import Vue from 'vue'
    import resource from 'vue-resource'
    import {deepCopyObject} from "../utility/util";

    Vue.use(resource);

    export default {
        name: "updateInfoSetting",
        data() {
            const validateProjectId = (rule, value, callback) => {
                //不允许为空
                if (!value || value.match(/^\s*$/)) {
                    callback(new Error('请选择项目'));
                } else {
                    callback();
                }
            };
            const validateStartDeviceId = (rule, value, callback) => {
                //不允许为空
                if (!value || value.match(/^\s*$/)) {
                    callback(new Error('请输入终端起始ID'));
                } else {
                    if ( !( /^[0-9]+$/.test(value) ) ){
                        callback(new Error('请输入0-9的字符'));
                    } else {
                        callback();
                    }
                }
            };
            const validateEndDeviceId = (rule, value, callback) => {
                //不允许为空
                if (!value || value.match(/^\s*$/)) {
                    callback(new Error('请输入终端结束ID'));
                } else {
                    if ( !( /^[0-9]+$/.test(value) ) ){
                        callback(new Error('请输入0-9的字符'));
                    } else if ( parseInt(this.updateInfo.startDeviceId,10) > parseInt(value,10) ) {
                        callback(new Error('应大于或等于终端起始ID'));
                    } else {
                        callback();
                    }
                }
            };
            const validateCodeId = (rule, value, callback) => {
                //不允许为空
                if (!value || value.match(/^\s*$/)) {
                    callback(new Error('请输入固件编号'));
                } else {
                    if (value.length !== 2) {
                        callback(new Error('请输入两位字符串'));
                    } else if ( !( /^[0-9A-F]+$/.test(value) ) ) {
                        callback(new Error('请输入0-9或A-F的字符'));
                    } else {
                        callback();
                    }
                }
            };
            const validateFIleName = (rule, value, callback) => {
                //不允许为空
                if (!value || value.match(/^\s*$/)) {
                    callback(new Error('请选择固件文件'));
                } else {
                    callback();
                }
            };
            return {
                refName: 'updateInfoSettingForm',
                updateInfo: {
                    codeId: '',
                    startDeviceId: '',
                    endDeviceId: '',
                    projectId: '',
                    fileName: '',
                    codeFile: null
                },
                ruleValidate: {
                    projectId: [
                        { validator: validateProjectId, trigger: 'change' }
                    ],
                    codeId: [
                        { validator: validateCodeId, trigger: 'blur'  }
                    ],
                    startDeviceId: [
                        { validator: validateStartDeviceId, trigger: 'blur'  }
                    ],
                    endDeviceId: [
                        { validator: validateEndDeviceId, trigger: 'blur'  }
                    ],
                    fileName: [
                        { validator: validateFIleName, trigger: 'change'  }
                    ]
                }
            }
        },
        mounted() {
            deepCopyObject(this.updateInfo, {
                projectId: this.$coreData.updateInfo.projectId,
                codeId: this.$coreData.updateInfo.codeId,
                startDeviceId: this.$coreData.updateInfo.startDeviceId,
                endDeviceId: this.$coreData.updateInfo.endDeviceId
            });
        },
        props: {
        },
        methods: {
            beforeUpload(file) {
                this.updateInfo.fileName = file.name;
                this.updateInfo.codeFile = file;
                this.$emit('clear-code');
                return false;       //停止上传
            },
            handleSubmit() {
                this.$refs[this.refName].validate((valid) => {
                    if (valid) {
                        let index = this.$coreData.projectList.findIndex(item => {
                            if (item.projectId === this.updateInfo.projectId) {
                                return true;
                            }

                            return false;
                        });
                        let projectName = this.$coreData.projectList[index].projectName;

                        let formData = new FormData();
                        formData.append('codeId', this.updateInfo.codeId);  //将当前固件版本编号信息加入
                        formData.append('projectId', this.updateInfo.projectId);  //将项目编号信息加入
                        formData.append('projectName', projectName);  //将项目名称信息加入
                        formData.append('startDeviceId', this.updateInfo.startDeviceId);  //将终端起始ID信息加入
                        formData.append('endDeviceId', this.updateInfo.endDeviceId);  //将终端结束ID信息加入
                        formData.append('code', this.updateInfo.codeFile);  //将代码文件信息加入
                        formData.append('uploader', this.$coreData.user.username);  //将上传者信息加入

                        // window.console.log(formData);
                        this.$coreData.upload(formData, (status, msg) => {
                            if (status === 'success') {
                                this.$coreData.updateInfo.codeString = msg;
                                sessionStorage.coreData = JSON.stringify(this.$coreData);
                                this.$Message.success('固件上传成功');
                                this.$emit('code-change');
                                // window.console.log('上传代码: '+ msg);
                            } else {
                                this.$Message.error(msg);
                                window.console.log('错误信息: '+ msg);
                            }
                        });

                        //保存上传数据
                        deepCopyObject(this.$coreData.updateInfo, {
                            codeId: this.updateInfo.codeId,
                            startDeviceId: this.updateInfo.startDeviceId,
                            endDeviceId: this.updateInfo.endDeviceId,
                            projectId: this.updateInfo.projectId,
                            projectName: projectName
                        });
                        sessionStorage.coreData = JSON.stringify(this.$coreData);
                    } else {
                        this.$Message.error('提交失败');
                    }
                });
            },
            handleReset() {
                this.$refs[this.refName].resetFields();
                this.$coreData.updateInfo.codeString = '';
                this.$coreData.resetUpdateInfo();
                this.$emit('code-change');
                window.console.log('reset');
            },
            getLastRecord() {
                this.$coreData.getLastRecord((status, msg) => {
                    if ((status === 'success') && msg) {
                        let updateConfig= JSON.parse(msg);
                        window.console.log(updateConfig);

                        deepCopyObject(this.$coreData.updateInfo, {
                            projectId: updateConfig.projectId,
                            projectName: updateConfig.projectName,
                            codeId: updateConfig.codeId,
                            startDeviceId: updateConfig.startDeviceId,
                            endDeviceId: updateConfig.endDeviceId,
                            codeString: updateConfig.code
                        });

                        deepCopyObject(this.updateInfo, {
                            projectId: this.$coreData.updateInfo.projectId,
                            codeId: this.$coreData.updateInfo.codeId,
                            startDeviceId: this.$coreData.updateInfo.startDeviceId,
                            endDeviceId: this.$coreData.updateInfo.endDeviceId,
                            fileName: '',
                            codeFile: null
                        });

                        //重置固件文件名校验
                        let field = this.$refs[this.refName].fields.find(item => {
                            if (item.prop === 'fileName') {
                                return true;
                            } else {
                                return false;
                            }
                        });
                        field.resetField();

                        sessionStorage.coreData = JSON.stringify(this.$coreData);
                        this.$Message.success('获取最近一次上传记录成功');
                        this.$emit('code-change');
                    } else {
                        this.$Message.error(msg);
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>